export const API_LANGUAGE = '/api/tfidf/language'
export const API_ANALYSIS = '/api/tfidf/analysis'
